// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2bJWi","balanceDisclaimer":"posDashboard_balanceDisclaimer__2oz7V"};